import { Button, Icon, Stack, Text } from '@pairy/pds-react';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';

import { CHANGE_LOGS } from '@/components/ChangeLog/constant';

import * as Styled from './index.styles';
import { Props } from './index.types';

const BannerCard = ({ tab, description, isAnimated, onClose }: Props) => {
  const { headline, thumbnail } = CHANGE_LOGS[tab];
  const [isClosing, setIsClosing] = useState(false);

  // 닫기 애니메이션이 끝난 뒤에 실제로 제거한다.
  const handleAnimationEnd = () => {
    if (isClosing) {
      onClose();
    }
  };

  return (
    <Styled.Card
      isAnimated={isAnimated}
      isClosing={isClosing}
      onAnimationEnd={handleAnimationEnd}
    >
      <Styled.CloseButton
        type="button"
        aria-label="업데이트 배너 닫기"
        onClick={() => setIsClosing(true)}
      >
        <Icon icon="ph:x" size={14} color="inherit" />
      </Styled.CloseButton>

      <Styled.ThumbnailWrapper>
        <Image
          src={thumbnail}
          layout="fill"
          objectFit="cover"
          sizes="320px"
          alt={headline}
        />
      </Styled.ThumbnailWrapper>

      <Stack gap={12} direction="column" padding={16}>
        <Stack gap={4} direction="column">
          <Text variant="sm-semibold" color="skyblue_500">
            새로운 업데이트
          </Text>
          <Text as="p" variant="lg-semibold" color="zinc_700">
            {headline}
          </Text>
          <Styled.Description as="p" variant="sm-medium" color="zinc_500">
            {description}
          </Styled.Description>
        </Stack>

        <Link href={`/change-log?tab=${tab}`}>
          <Button
            variant="skyblue_400_fill"
            textVariant="md-medium"
            width="100%"
            rightIcon={<Icon icon="ph:caret-right" size={16} color="white" />}
            onClick={onClose}
          >
            업데이트 보기
          </Button>
        </Link>
      </Stack>
    </Styled.Card>
  );
};

export default BannerCard;
